import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerQuestionnaireService } from '../../../../services/customer-questionnaire.service';
import { EmptyStateType } from '../../../../../../../common-modules/components/components/empty-state/empty-state.component';

@Component({
    selector: 'app-check-submit',
    templateUrl: './check-submit.component.html',
    styleUrls: ['./check-submit.component.scss'],
    standalone: false,
})
export class CheckSubmitComponent {
    @Input() type: 'mandatory_questions_finished' | 'entire_questionnaire_finished';
    @Output() resumeQuestionnaire = new EventEmitter<{
        status: boolean;
        type: 'start' | 'resume';
        isContinue?: boolean;
    }>();

    constructor(public customerQuestionnaireService: CustomerQuestionnaireService) {}

    public onResumeQuestionnaire($event: any) {
        this.customerQuestionnaireService.showCheckSubmit = false;
        this.resumeQuestionnaire.emit({ status: true, type: 'resume', isContinue: true });
    }

    public enableContinueButton(): boolean {
        return !this.customerQuestionnaireService.areAllQuestionsAnswered();
    }

    public getLogoType(): EmptyStateType {
        if (this.customerQuestionnaireService.displayVersion === 'full' && !this.customerQuestionnaireService.areAllQuestionsAnswered()) {
            return 'noData';
        }

        if (
            this.customerQuestionnaireService.displayVersion === 'condensed' &&
            !this.customerQuestionnaireService.areAllMandatoryQuestionsAnswered()
        ) {
            return 'noData';
        }

        return 'success';
    }
}
